export const createSlug = (key) => {
  return key.toLowerCase().replace(/ /g, '-').replace(/[?]/g, '')
}

export const reverseSlug = (slug, content) => {
  for (const key in content) {
    if (createSlug(key) === slug) {
      return key
    }
  }
  return null
}

export const getLocalizedPath = (locale, category, subCategory, topic) => {
  const basePath = locale === 'en' ? '/wbso-knowledge-base' : '/wbso-kennisbank'
  if (topic) {
    return `${basePath}/${createSlug(category)}/${createSlug(subCategory)}/${createSlug(topic)}`
  }
  if (subCategory) {
    return `${basePath}/${createSlug(category)}/${createSlug(subCategory)}`
  }
  return `${basePath}/${createSlug(category)}`
}
